"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import $ from "jquery";
import _ from "underscore";
import Auth from "../util/auth";
import Autolinker from "autolinker";
import { Flash } from "../components/flash";
import React from "react";
import ReactDOM from "react-dom";
import DataStoreService from "../accounts_payable/data_store_service";
import presenceService from "./presence_service_next_gen";
import * as navigation from "../elm19/hubtran/navigation";
import Ports from "../elm19/hubtran/ports";
import UiV3 from "../elm19/ui_v3";
import * as popout from "./popout";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
import Hotkeys from "../util/hotkeys";
import { getOktaSignIn } from "../util/okta";
import { OktaAuth } from "@okta/okta-auth-js";
import AccountsPayable from "../accounts_payable";
import { reportDecodingError } from "../honeybadger";
import "./custom_elements/factor_invoice";
import "./custom_elements/exception_sender";
import "./custom_elements/email_forwarder";
import "./custom_elements/email_merger";
import "./custom_elements/ignore_entry";
import { Elm } from "../../elm/accounts-payable/src/Main.elm";
import Core from "@uppy/core";
import DragDrop from "@uppy/drag-drop";
import StatusBar from "@uppy/status-bar";
import XHRUpload from "@uppy/xhr-upload";
import Honeybadger from "@honeybadger-io/js";
export default React.createClass({
  getInitialState() {
    return { app: null };
  },
  componentDidMount() {
    const content = ReactDOM.findDOMNode(this);
    const propLocation = this.props.location;
    const app = Elm.Main.init({
      node: content,
      flags: {
        initialLocation: window.location.href,
        mainFlags: this.props.headerFlags
      }
    });
    const ports = new Ports(app);
    window.$elmPorts = ports;
    navigation.init(app, window.$hubtranHistory);
    presenceService.registerElmApp(this);
    UiV3.applyPorts(app);
    const oktaConfig = JSON.parse(window.oktaConfig);
    const authClient = new OktaAuth({
      issuer: oktaConfig.issuer,
      clientId: oktaConfig.clientId,
      redirectUri: oktaConfig.callbackUri
    });
    const loginViaToken = function(accessToken) {
      Auth.login(accessToken).then(() => {
        const location2 = propLocation;
        var destination = "/";
        if (location2.state && location2.state.nextPathname) {
          const nextPathname = location2.state.nextPathname;
          if (nextPathname.startsWith("/") && !nextPathname.startsWith("/app")) {
            destination = "/app" + nextPathname;
          } else {
            destination = nextPathname;
          }
        }
        window.location.href = destination;
      }).catch((error) => {
        const response = error.response;
        if (response.status === 401 || response.status === 403) {
          console.log(`unauthorized`, error);
          ports.safeSend("failedOktaAuth", "unauthorized");
          authClient.closeSession();
        } else {
          console.log(`an error occurred`, error);
        }
      });
    };
    const showOktaSignIn = function({ elementId, flow, state, email, error }) {
      const signInWidget = getOktaSignIn(authClient, flow, state, email);
      const renderSignIn = function() {
        requestAnimationFrame(function() {
          const match = document.getElementById(elementId);
          if (match == null) {
            throw `unable to locate element to setup Okta sign in: ${elementId}`;
          }
          signInWidget.showSignIn({ el: `#${elementId}` }).then(function(res) {
            const accessToken = res.tokens.accessToken.accessToken;
            loginViaToken(accessToken);
          }).catch(function(error2) {
            console.log(`Okta setup error`, error2);
          });
        });
      };
      const interactionRequired = error == "interaction_required";
      const oktaStatePresent = state.length > 0;
      if (interactionRequired || oktaStatePresent) {
        renderSignIn();
      } else if (authClient.isLoginRedirect()) {
        authClient.handleRedirect();
      } else {
        if (flow == "login") {
          localStorage.removeItem("okta-cache-storage");
          localStorage.removeItem("okta-shared-transaction-storage");
          sessionStorage.removeItem("okta-transaction-storage");
        }
        renderSignIn();
      }
    };
    ports.safeSubscribe("flashToJavascript", function(message) {
      ports.safeSend("flashFromJavascriptMaybeV3Reskin", message);
    });
    ports.safeSubscribe("flashToJavascriptLegacy", function(message) {
      Flash.messagesAtLevel(message.level, message.message, {
        timeout: message.time
      });
    });
    ports.safeSubscribe("flashToJavascriptV3Reskin", function(message) {
      message.time = Date.now();
      ports.safeSend("flashFromJavascript", message);
    });
    ports.safeSubscribe("copyToClipboard", function(toCopy) {
      const el = document.createElement("textarea");
      el.value = toCopy;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ports.safeSend("copiedToClipboard", toCopy);
    });
    ports.safeSubscribe("sendToDataStoreService", function(data) {
      DataStoreService.responseHandler(data);
    });
    ports.safeSubscribe("autolink", function(selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.innerHTML = Autolinker.link(el.innerHTML);
      }
    });
    ports.safeSubscribe("openBeamer", function() {
      if (beamerExists()) {
        Beamer.show();
      }
    });
    ports.safeSubscribe("refreshBeamerCount", function() {
      return __async(this, null, function* () {
        const beamerMessageCount = yield getBeamerMessageCount();
        ports.safeSend("beamerMessageCount", beamerMessageCount);
      });
    });
    ports.safeSubscribe("navigateToReactPath", function(url) {
      if (url.startsWith("/app/")) {
        url = url.slice(4);
      }
      window.$hubtranHistory.push(url);
      app.ports.onUrlChange.send(location.href);
    });
    ports.safeSubscribe("openUrlInNewTab", function(url) {
      window.open(url, "_blank");
    });
    ports.safeSubscribe(
      "switchGroupUserAccount",
      this.props.switchUserCallback
    );
    ports.safeSubscribe("toggleReskinUser", this.props.toggleReskin);
    ports.safeSubscribe("reportError", reportDecodingError);
    document.addEventListener("keydown", function(event) {
      if (event.target && event.target.tagName == "BODY") {
        ports.safeSend("onDocumentKeyDown", event);
      }
    });
    window.addEventListener("beforeunload", function(event) {
      const isDocumentViewerBeingClosed = event.currentTarget && // @ts-expect-error - TODO: fix TypeScript error
      event.currentTarget.name === popout.DOC_VIEWER_POPOUT_NAME;
      if (popout.isDocumentViewerOpen() && isDocumentViewerBeingClosed) {
        popout.closeDocumentViewer();
      }
    });
    ports.safeSubscribe("closeDocumentViewer", function(document2) {
      popout.setViewEmailForwardData(JSON.stringify(document2));
      popout.closeDocumentViewer();
      window.close();
    });
    ports.safeSubscribe("scrollToId", function(id) {
      requestAnimationFrame(function() {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ block: "start" });
        }
      });
    });
    function scrollableAncestor(el) {
      for (let node = el.parentElement; node; node = node.parentElement) {
        const style = getComputedStyle(node);
        const scrolls = (overflow, scrollSize, clientSize) => (overflow === "auto" || overflow === "scroll") && scrollSize > clientSize;
        if (scrolls(style.overflowY, node.scrollHeight, node.clientHeight) || scrolls(style.overflowX, node.scrollWidth, node.clientWidth)) {
          return node;
        }
      }
      return null;
    }
    ports.safeSubscribe("scrollToIdIfNeeded", function(id) {
      requestAnimationFrame(function() {
        const el = document.getElementById(id);
        if (!el) {
          return;
        }
        const container = scrollableAncestor(el);
        if (!container) {
          el.scrollIntoView({ block: "center", inline: "center" });
          return;
        }
        const elBox = el.getBoundingClientRect();
        const containerBox = container.getBoundingClientRect();
        const centerOffset = (elStart, elEnd, boxStart, boxSize, elSize) => elStart >= boxStart && elEnd <= boxStart + boxSize ? 0 : elStart - boxStart - (boxSize - elSize) / 2;
        container.scrollTop += centerOffset(
          elBox.top,
          elBox.bottom,
          containerBox.top,
          containerBox.height,
          elBox.height
        );
        container.scrollLeft += centerOffset(
          elBox.left,
          elBox.right,
          containerBox.left,
          containerBox.width,
          elBox.width
        );
      });
    });
    function eachWithContext(role, context, callback) {
      document.querySelectorAll(`[data-${role}=${context}]`).forEach(callback);
    }
    ports.safeSubscribe("setupDragHandlers", function(context) {
      requestAnimationFrame(function() {
        eachWithContext("drag", context, function(el) {
          el.draggable = true;
          el.ondragstart = function(event) {
            event.dataTransfer.setData("text/context", context);
            event.dataTransfer.setData("text/plain", event.target.title);
          };
        });
      });
    });
    ports.safeSubscribe("setupDropHandlers", function(context) {
      requestAnimationFrame(function() {
        eachWithContext("drop", context, function(el) {
          el.ondragover = (event) => event.preventDefault();
          el.ondrop = function(event) {
            if (event.dataTransfer.getData("text/context") === context) {
              event.preventDefault();
              const value = event.dataTransfer.getData("text/plain");
              this.dispatchEvent(new CustomEvent("x-drop", { detail: value }));
            }
          };
        });
      });
    });
    var presenceChangedCallback;
    ports.safeSubscribe("setUserPresence", function(path) {
      presenceService.userMovedTo(path);
      if (presenceChangedCallback) {
        $(presenceService).off(
          "presence_service:updated",
          presenceChangedCallback
        );
      }
      presenceChangedCallback = () => {
        const data = presenceService.getLocationData(path);
        const others = _.map(
          presenceService.getOtherUsers(data),
          (x) => x.name
        );
        setTimeout(
          () => ports.safeSend("onOthersPresence", { path, others }),
          0
        );
      };
      presenceChangedCallback();
      $(presenceService).on(
        "presence_service:updated",
        presenceChangedCallback
      );
    });
    ports.safeSubscribe("setCarrierPresence", function(carrierId) {
      presenceService.didStartViewingCarrier(carrierId);
    });
    ports.safeSubscribe("setupNewFactorInvoiceCreated", function() {
      $(presenceService).on(
        "presence_service:invoiceCreated",
        function(event, data) {
          ports.safeSend("onFactorInvoiceCreated", data.factor_invoice.id);
        }
      );
    });
    let setupAddDocumentToLoadSubscribed = false;
    ports.safeSubscribe("setupAddDocumentToLoad", function() {
      if (!setupAddDocumentToLoadSubscribed) {
        $(DataStoreService).on(
          "DataStoreService:addDocumentToLoad",
          function(event, data) {
            ports.safeSend("onAddDocumentToLoadUploadFinished", data);
          }
        );
        setupAddDocumentToLoadSubscribed = true;
      }
    });
    let setupLtlPayablesCarrierInvoiceSubmissionImportSubscribed = false;
    ports.safeSubscribe(
      "setupLtlPayablesCarrierInvoiceSubmissionImport",
      function() {
        if (!setupLtlPayablesCarrierInvoiceSubmissionImportSubscribed) {
          $(DataStoreService).on(
            "DataStoreService:ltlPayablesCarrierInvoiceSubmissionImport",
            function(event, data) {
              ports.safeSend(
                "ltlPayablesCarrierInvoiceSubmissionImportFinished",
                data
              );
            }
          );
          setupLtlPayablesCarrierInvoiceSubmissionImportSubscribed = true;
        }
      }
    );
    function presenceAndCarrierFromPath(path) {
      const data = presenceService.getLocationData(path);
      const others = _.map(presenceService.getOtherUsers(data), (x) => x.name);
      var carrier = null;
      function getCarrierFromState(appStateEntry) {
        if (appStateEntry.batchId && appStateEntry.batchId == data.batchId) {
          carrier = appStateEntry.carrierId;
        } else if (appStateEntry.emailId && appStateEntry.emailId == data.emailId) {
          carrier = appStateEntry.carrierId;
        } else if (appStateEntry.loadId && appStateEntry.loadId == data.loadId) {
          carrier = appStateEntry.carrierId;
        } else if (appStateEntry.factorInvoiceId && appStateEntry.factorInvoiceId == data.factorInvoiceId) {
          carrier = appStateEntry.carrierId;
        }
      }
      _.map(presenceService.appState, getCarrierFromState);
      carrier = carrier ? carrier : null;
      return { path, others, carrier };
    }
    let lastPrefetchedEmailId = null;
    ports.safeSubscribe(
      "maybePrefetchNextFlowModeItem",
      function(_0) {
        return __async(this, arguments, function* ([onDone, emailId]) {
          if (emailId != lastPrefetchedEmailId) {
            lastPrefetchedEmailId = emailId;
            yield maybePrefetchNextFlowModeItem({ query: { onDone } });
          }
        });
      }
    );
    ports.safeSubscribe("listenToPresenceUpdate", function() {
      const listenToPresenceUpdateCallback = () => {
        if (localStorage.getItem("HUBTRAN_PRESENCE_LOGGING"))
          console.log("onPresenceUpdate send");
        const allPaths = _.map(presenceService.appState, (x) => x.path);
        const presences = _.map(allPaths, presenceAndCarrierFromPath);
        ports.safeSend("onPresenceUpdate", presences);
      };
      setTimeout(listenToPresenceUpdateCallback, 0);
      $(presenceService).on(
        "presence_service:updated",
        listenToPresenceUpdateCallback
      );
    });
    ports.safeSubscribe("setupCurrentProcessingSelectionUpdates", function() {
      const setupCurrentProcessingSelectionUpdatesCallback = (newValue) => {
        if (!newValue) {
          return;
        }
        const [source, selection] = JSON.parse(newValue);
        if (source === popout.CURRENT_PROCESSING_SELECTION_SOURCE_MAIN_VIEWER) {
          ports.safeSend("onCurrentProcessingSelectionUpdate", selection);
        }
      };
      const setupCurrentProcessingSelectedRefreshCallback = () => {
        ports.safeSend("onCurrentProcessingSelectionRefresh", null);
      };
      const setupDocumentViewerPageDataUpdatesCallback = () => {
        const key = popout.DOCUMENT_VIEWER_PAGE_CONTEXT_DATA_KEY;
        const localStorageValue = window.localStorage.getItem(key);
        const pageData = JSON.parse(localStorageValue || "{}");
        ports.safeSend("onDocumentViewerPageContextDataUpdate", pageData);
      };
      setTimeout(
        () => setupCurrentProcessingSelectionUpdatesCallback(
          localStorage.getItem(popout.CURRENT_PROCESSING_SELECTION_KEY)
        )
      );
      setTimeout(setupDocumentViewerPageDataUpdatesCallback);
      window.addEventListener("storage", (event) => {
        if (event.key === popout.REFRESH_KEY) {
          setupCurrentProcessingSelectedRefreshCallback();
        }
        if (event.key === popout.CURRENT_PROCESSING_SELECTION_KEY) {
          setupCurrentProcessingSelectionUpdatesCallback(event.newValue);
        }
        if (event.key == popout.DOCUMENT_VIEWER_PAGE_CONTEXT_DATA_KEY) {
          setupDocumentViewerPageDataUpdatesCallback();
        }
      });
    });
    ports.safeSubscribe(
      "updateCurrentProcessingSelection",
      function(selection) {
        const value = JSON.stringify([
          popout.CURRENT_PROCESSING_SELECTION_SOURCE_POPOUT,
          selection
        ]);
        window.localStorage.setItem(
          popout.CURRENT_PROCESSING_SELECTION_KEY,
          value
        );
      }
    );
    ports.safeSubscribe("setupHoveredTextFromMainPageUpdates", function() {
      const setupHoveredTextFromMainPageUpdatesCallback = () => {
        const maybeHoveredText = localStorage.getItem(
          popout.HOVERED_TEXT_FROM_MAIN_PAGE_KEY
        );
        let hoveredText = null;
        if (maybeHoveredText && maybeHoveredText !== "") {
          hoveredText = maybeHoveredText;
        }
        ports.safeSend("onHoveredTextFromMainPageUpdate", hoveredText);
      };
      setTimeout(setupHoveredTextFromMainPageUpdatesCallback);
      window.addEventListener("storage", (event) => {
        if (event.key === popout.HOVERED_TEXT_FROM_MAIN_PAGE_KEY) {
          setupHoveredTextFromMainPageUpdatesCallback();
        }
      });
    });
    ports.safeSubscribe("documentPageLineFromPopout", function(line) {
      window.localStorage.setItem(
        popout.DOCUMENT_PAGE_LINE_FROM_POPOUT_KEY,
        JSON.stringify(line)
      );
    });
    ports.safeSubscribe("setDocumentPodUpdate", function(updates) {
      popout.setDocumentPodUpdate(updates);
    });
    ports.safeSubscribe("initUppy", function(options) {
      var uppy = new Core({
        autoProceed: true,
        debug: true,
        restrictions: {
          maxNumberOfFiles: options.singleFile ? 1 : null,
          allowedFileTypes: options.allowedFileTypes
        }
      }).use(DragDrop, {
        target: options.dragDropTarget,
        replaceTargetContent: true
      }).use(StatusBar, {
        target: options.statusBarTarget
      }).use(XHRUpload, {
        endpoint: options.endpoint,
        fieldName: "file",
        getResponseData(xmlHttpRequest) {
          try {
            const data = JSON.parse(xmlHttpRequest.responseText);
            return {
              url: data.url
            };
          } catch (e) {
            Honeybadger.notify(e);
            return { url: void 0 };
          }
        }
      });
      uppy.on("upload-success", (file, response) => {
        uppy.destroy();
        ports.safeSend("uppyFileUploaded", response.body);
      });
    });
    ports.safeSubscribe("showOktaSignIn", showOktaSignIn);
    ports.safeSubscribe("updateAuthUser", function(updatedUserJson) {
      Auth.save(updatedUserJson);
      window.$hubtranHistory.push("/");
    });
    if (popout.isDocumentViewerOpen()) {
      Hotkeys.listenInComponent(this, AccountsPayable, {
        zoomIn: () => ports.safeSend("onHotkeyInput", "zoomIn"),
        zoomOut: () => ports.safeSend("onHotkeyInput", "zoomOut"),
        nextPage: () => ports.safeSend("onHotkeyInput", "nextPage"),
        prevPage: () => ports.safeSend("onHotkeyInput", "prevPage"),
        togglePOD: () => ports.safeSend("onHotkeyInput", "togglePOD"),
        nextGroup: () => ports.safeSend("onHotkeyInput", "nextGroup"),
        prevGroup: () => ports.safeSend("onHotkeyInput", "prevGroup"),
        rotateLeft: () => ports.safeSend("onHotkeyInput", "rotateLeft"),
        rotateRight: () => ports.safeSend("onHotkeyInput", "rotateRight"),
        toggleHidden: () => ports.safeSend("onHotkeyInput", "toggleHidden")
      });
    }
    this.setState({ app });
  },
  pushDataUpdate(data) {
    var normalizedData = data.graph || {};
    for (var attrname in data) {
      if (attrname == "graph") {
        continue;
      } else if (attrname == "elm_document_page") {
        normalizedData["documentPage"] = data["elm_document_page"];
      } else {
        normalizedData[attrname] = data[attrname];
      }
    }
    if (this.state.app) {
      this.state.app.ports.onPusherDataUpdate.send({ graph: normalizedData });
    }
  },
  shouldComponentUpdate(nextProps) {
    return false;
  },
  render() {
    return /* @__PURE__ */ React.createElement("div", null);
  },
  updateHeaderFlags(flags) {
    if (this.state.app) {
      this.state.app.ports.updateHeaderFlags.send(flags);
    }
  }
});
function beamerExists() {
  return typeof Beamer !== "undefined";
}
function getBeamerMessageCount() {
  return new Promise(function(res, rej) {
    try {
      if (beamerExists()) {
        Beamer.update({
          callback: function(messageCount) {
            res(messageCount);
          }
        });
      } else {
        res(0);
      }
    } catch (error) {
      rej(error);
    }
  });
}
